module.exports = __webpack_public_path__ + "assets/img/empty-new.8d791cc3.png";